"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEEK_STEP_SECONDS = void 0;
const react_1 = __importStar(require("react"));
const Colors_1 = require("../../../../../Colors");
const common_1 = require("../../../../../common");
const FullScreenBtn_1 = __importDefault(require("./FullScreenBtn"));
const types_1 = require("./types");
const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
const isMobileDevice = () => {
    const mobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return (mobileDevice ||
        (window.matchMedia('(max-width: 767px)').matches &&
            window.matchMedia('(min-height: 450px)').matches));
};
let customTime;
/** 10초 이동(요청 사양) — 방향키 / 좌·우 영역 더블탭 공통 */
exports.SEEK_STEP_SECONDS = 10;
/** 더블탭 인정 간격(ms). 이 시간 안에 같은 쪽을 한 번 더 누르면 이동, 아니면 컨트롤 표시 토글 */
const DOUBLE_TAP_MS = 280;
const CustomControls = ({ videoRef, playing, onPlay, onPause, duration, currentTime, onSeek, volume, onVolumeChange, handlerFullScreen, handlerExitFullScreen, availableQualities, selectedQuality, handleQualityChange, playbackRate, onPlaybackRateChange, }) => {
    const [isHovering, setIsHovering] = (0, react_1.useState)(true);
    const [controlsVisible, setControlsVisible] = (0, react_1.useState)(true); // 하단 바 표시 여부 관리하는 상태
    // 더블탭 피드백(‹‹ 10초 / 10초 ››) — 잠깐 표시했다 사라진다
    const [seekHint, setSeekHint] = (0, react_1.useState)(null);
    const progressRef = (0, react_1.useRef)(null);
    const lastTapRef = (0, react_1.useRef)({
        time: 0,
        side: null,
    });
    const singleTapTimerRef = (0, react_1.useRef)(null);
    const hintTimerRef = (0, react_1.useRef)(null);
    // 현재 재생 위치에서 delta 초만큼 이동(0 ~ duration 으로 제한)
    const seekBy = (delta) => {
        if (!duration)
            return;
        const next = Math.min(Math.max(currentTime + delta, 0), duration);
        onSeek(next);
        setSeekHint(delta < 0 ? 'back' : 'forward');
        if (hintTimerRef.current)
            clearTimeout(hintTimerRef.current);
        hintTimerRef.current = setTimeout(() => setSeekHint(null), 600);
    };
    (0, react_1.useEffect)(() => {
        return () => {
            if (singleTapTimerRef.current)
                clearTimeout(singleTapTimerRef.current);
            if (hintTimerRef.current)
                clearTimeout(hintTimerRef.current);
        };
    }, []);
    const handlePlayPause = () => {
        if (playing) {
            onPause();
        }
        else {
            onPlay();
        }
    };
    const toggleControlsVisibility = (e) => {
        if (e.target === progressRef.current)
            return; // 클릭 이벤트가 하단 바 위에서 발생한 경우 무시
        // 모바일/태블릿: 영상 좌·우 영역 더블탭으로 10초 이동(유튜브 모바일과 동일한 조작).
        // 한 번만 누른 경우는 기존대로 컨트롤 표시 토글 — 더블탭 판정을 위해 잠깐 미뤘다 실행한다.
        if (isMobileDevice()) {
            const rect = e.currentTarget.getBoundingClientRect();
            const side = e.clientX - rect.left < rect.width / 2 ? 'back' : 'forward';
            const now = Date.now();
            const isDoubleTap = now - lastTapRef.current.time < DOUBLE_TAP_MS && lastTapRef.current.side === side;
            if (isDoubleTap) {
                if (singleTapTimerRef.current)
                    clearTimeout(singleTapTimerRef.current);
                lastTapRef.current = { time: 0, side: null };
                seekBy(side === 'back' ? -exports.SEEK_STEP_SECONDS : exports.SEEK_STEP_SECONDS);
                return;
            }
            lastTapRef.current = { time: now, side };
            if (singleTapTimerRef.current)
                clearTimeout(singleTapTimerRef.current);
            singleTapTimerRef.current = setTimeout(() => setControlsVisible(prevState => !prevState), DOUBLE_TAP_MS);
            return;
        }
        setControlsVisible(prevState => !prevState); // 하단 바 표시/숨김 전환
    };
    const handleSeekChange = (e) => {
        const progressBarElement = progressRef.current;
        if (!progressBarElement)
            return;
        const rect = progressBarElement.getBoundingClientRect();
        const seekPosition = (e.clientX - rect.left) / rect.width;
        onSeek(seekPosition * duration);
    };
    const handleVolumeIconClick = () => {
        onVolumeChange(volume === 0 ? 1 : 0);
    };
    const progressPercentage = isNaN(currentTime / duration)
        ? 0
        : Math.max((currentTime / duration) * 100, 0);
    const handleMouseEnter = () => {
        if (customTime)
            clearTimeout(customTime);
        setIsHovering(true);
    };
    const handleMouseLeave = () => {
        customTime = setTimeout(() => setIsHovering(false), 3000);
    };
    const handleMouseMove = () => {
        if (customTime)
            clearTimeout(customTime);
        if (!isHovering)
            setIsHovering(true);
        customTime = setTimeout(() => setIsHovering(false), 5000);
    };
    const qualityOptions = (0, react_1.useMemo)(() => [
        { id: 'auto', title: 'Auto' },
        ...availableQualities.map(quality => ({
            id: quality.qualityIndex.toString(),
            title: `${quality.height}p (${quality.bitrate} kbps)`,
        })),
    ], [availableQualities]);
    const rateValue = types_1.PLAYBACK_RATES.find(option => Number(option.id) === playbackRate) ?? types_1.PLAYBACK_RATES[2];
    return (react_1.default.createElement("div", { className: "custom-controls", onClick: toggleControlsVisibility, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onMouseMove: handleMouseMove, onTouchStart: handleMouseEnter, onTouchEnd: handleMouseLeave, onMouseDown: handleMouseEnter },
        seekHint && (react_1.default.createElement("div", { className: `seek-hint ${seekHint}` }, seekHint === 'back' ? `« ${exports.SEEK_STEP_SECONDS}초` : `${exports.SEEK_STEP_SECONDS}초 »`)),
        react_1.default.createElement("div", { className: "controls-container", style: { display: controlsVisible ? 'flex' : 'none' }, onClick: e => e.stopPropagation() },
            react_1.default.createElement("div", { id: "progress-bar", className: "progress-bar-container", ref: progressRef, onClick: handleSeekChange },
                react_1.default.createElement("div", { className: "full-progress-bar", style: { width: `${progressPercentage}%` } }),
                react_1.default.createElement("div", { className: "progress-bar", style: { left: `${progressPercentage}%` } })),
            react_1.default.createElement("div", { className: "controls-row" },
                react_1.default.createElement("div", { className: "left_wrap" },
                    react_1.default.createElement(common_1.Button, { option: {
                            buttonBeforeIcon: {
                                show: true,
                                name: playing ? 'vodPause' : 'vodStart',
                                size: 25,
                                color: playing ? '#8bacff' : '#fff',
                                className: 'handlerIcon',
                            },
                        }, onClick: handlePlayPause }),
                    react_1.default.createElement("div", { className: "time-display" },
                        formatTime(currentTime),
                        " / ",
                        formatTime(duration)),
                    react_1.default.createElement("div", { className: "volume-control" },
                        react_1.default.createElement(common_1.Button, { option: {
                                buttonBeforeIcon: {
                                    show: true,
                                    name: volume === 0 ? 'vodVolumeOff' : 'vodVolumeOn',
                                    size: 25,
                                    color: volume === 0 ? Colors_1.Colors.accent : '#fff',
                                    className: 'handlerIcon',
                                },
                            }, onClick: handleVolumeIconClick }),
                        !isMobileDevice() && (react_1.default.createElement("input", { className: "volume-slider", type: "range", min: "0", max: "1", step: "0.1", value: volume, onChange: e => onVolumeChange(parseFloat(e.target.value)) })))),
                react_1.default.createElement("div", { className: "left_wrap" },
                    react_1.default.createElement("div", { className: "speed-selector" },
                        react_1.default.createElement(common_1.DropDown, { noShowButtonArea: true, className: "dropdown-live", value: rateValue, list: types_1.PLAYBACK_RATES, setDropValue: item => onPlaybackRateChange(Number(item.id)), styles: {
                                dropWrap: {
                                    minWidth: 90,
                                    maxWidth: 120,
                                },
                                titleWrap: {
                                    background: Colors_1.Colors.transparent,
                                },
                                titleText: {
                                    color: Colors_1.Colors.white,
                                },
                            }, option: {
                                downIcon: {
                                    color: '#fff',
                                },
                            }, isDisable: false })),
                    react_1.default.createElement("div", { className: "quality-selector" },
                        react_1.default.createElement(common_1.DropDown, { noShowButtonArea: true, className: "dropdown-live", value: qualityOptions.find(option => option.id === selectedQuality.toString()), list: qualityOptions, setDropValue: item => {
                                handleQualityChange(item.id === 'auto' ? 'auto' : parseInt(item.id, 10));
                            }, styles: {
                                dropWrap: {
                                    minWidth: 120,
                                    maxWidth: 200,
                                },
                                titleWrap: {
                                    background: Colors_1.Colors.transparent,
                                },
                                titleText: {
                                    color: Colors_1.Colors.white,
                                },
                            }, option: {
                                downIcon: {
                                    color: '#fff',
                                },
                            }, isDisable: false })),
                    react_1.default.createElement(FullScreenBtn_1.default, { autoPlay: false, className: "screen-full-btn", video: videoRef.current, handlerFullScreen: handlerFullScreen, handlerExitFullScreen: handlerExitFullScreen }))))));
};
exports.default = CustomControls;
